module.exports = __webpack_public_path__ + "static/casestudypage_pinduk-f90b4670556ad063892a05b76b4bbd89.webp";